export default "__VITE_ASSET__BsUcswN3__"